var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trabalhos"},[_c('Container',[_c('h1',[_vm._v("\n      Uma equipe criativa e talentosa ajudando marcas a atingirem todo seu\n      potencial.\n    ")]),_c('FilterButton')],1),_c('TagList'),_c('WorkList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }